import React from "react";
import styled from 'styled-components';
import { GenericFormContext } from '../../../../context/genericFormContext';
import ClaroDiv from "../../../atoms/ClaroDiv";
import { validationStyles } from '../utils/index'
import ClaroParagraph from '../../../atoms/ClaroParagraph'
import ClaroSubtitleButton from '../../../atoms/ClaroSubtitleButton'
import { ARCUS_BILLER_IDS } from "../../../../constants";
import { validateUserAgent } from "../../utils";
import { connect } from "react-redux";


const Container = styled.div`
    width: 100%;
`;

const AmountWrap = styled.div`
    ${props => props.giftImage ? `background-image: url("${props.giftImage}")` : ""};
    ${props => props.giftImage && props.value && props.value.length === 2 ? "background-position: calc(50% + 95px) 41%" : ""};
    ${props => props.giftImage && props.value && props.value.length === 3 ? "background-position: calc(50% + 112px) 41%" : ""};
    ${props => props.giftImage && props.value && props.value.length >= 5 ? "background-position: calc(50% + 138px) 41%" : ""};
    ${props => props.giftImage ? "background-size: auto 25px" : ""};
    ${props => props.giftImage ? "background-repeat: no-repeat" : ""};
`;

const ClaroDivPesos = styled.div`
    text-align: center;
    font-size: ${props => props.fontSize ? props.fontSize : '1.5rem'};
    line-height: ${props => props.lineHeight ? props.lineHeight : 'auto'};
    font-family: ${props => props.fontFamily ? props.fontFamily : 'Amx-Regular'};
    display: ${props => props.display ? props.display : 'none'};
    width: ${props => props.width ? props.width : 'auto'};
    height: ${props => props.height ? props.height : 'auto'};
    font-weight: bold;
`
const ClaroInputFieldPesos = styled.input`
margin: ${props => props.margin ? props.margin : '0rem'};
padding: ${props => props.padding ? props.padding : '0rem'};
-webkit-appearance: none;
border-radius: 0;
height: ${props => props.height ? props.height : 'auto'};
min-height: ${props => props.height ? props.height : '34px'};
font-family: ${props => props.fontFamily ? props.fontFamily : 'Amx-Regular'};
font-weight: ${props => props.fontWeight ? props.fontWeight : ''};
color: ${props => props.color ? props.color : '#323232'};
font-size: ${props => props.fontSize ? props.fontSize : '0.7rem'};
line-height: ${props => props.lineHeight ? props.lineHeight : 'auto'};
vertical-align: ${props => props.verticalAlign ? props.verticalAlign : 'middle'};
border-style: ${props => props.borderStyle ? props.borderStyle : 'none'};
background: ${props => props.background ? props.background : 'transparent'};
border-bottom: ${props => props.borderBottom ? props.borderBottom : '1px solid #26012024'};
width: ${props => props.width ? props.width : 'auto'};
text-align: ${props => props.textAlign ? props.textAlign : 'left'};
outline: ${props => props.outline ? props.outline : 'none'}; 
flex-grow: ${props => props.flexGrow ? props.flexGrow : '1'};
max-width: ${props => props.userAgentIsAndroid ? '85%' : '82%'};
cursor: pointer;
&:focus {
    outline: none;
}
::placeholder {
    margin: ${props => props.margin ? props.margin : '0rem'};
    padding: ${props => props.padding ? props.padding : '0rem'};
    color: ${props => props.phColor ? props.phColor : '#323232'};
    font-size: ${props => props.fontSize ? props.fontSize : '0.7rem'};
    line-height: ${props => props.lineHeight ? props.lineHeight : 'auto'};
    vertical-align: ${props => props.verticalAlign ? props.verticalAlign : 'middle'};
    font-family: ${props => props.fontFamily ? props.fontFamily : 'Amx-Regular'};
    text-align: ${props => props.textAlign ? props.textAlign : 'left'};
    font-weight: ${props => props.fontWeight ? props.fontWeight : ''};
}
`

const ArcusButtonsWrap = styled.div`
    margin-top: 24px;
    margin-bottom: 40px;
    display: flex;
    align-items: center;
    justify-content: center
`;

const ArcusButton = styled.div`
    padding: ${props => props.padding ? props.padding : '0rem'};
    width: 98px;
    border-radius: 5px;
    box-shadow: 0px 0px 30px 0px #19012024;
    display: inline-block;
    margin: ${props => props.margin ? props.margin : '0rem'};
    font-family: 'Amx-Regular' !important;
    font-size: 12px;
    font-weight: 800;
    color: ${props => props.color ? props.color : '#000'};
    height: 76px;
    text-align: center;
    letter-spacing: ${validateUserAgent() === 'android' ? '0px' : '-1px'}
`;

class AmountInputClaroSocio extends React.Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            showArcusOCRButton: false,
            showBalanceButton: false
        }
    }

    componentDidMount() {        
        const destAccountId = this.props.dataConfigInputs.find(item => item.id === "destAccountId");
        if (destAccountId && destAccountId.field.button) {
           this.setState({showArcusOCRButton: true})
        }
        if (destAccountId &&  destAccountId.distpatchGetAmount) {
            this.setState({showBalanceButton: true})
        }
    }

    render() {
        const { appSyncValues, giftImage, creditCardInfo } = this.props
        let validation = validationStyles(this.props.isValid);

        let styles = {
            "fontSize": "58px",
            "line-height": "58px",
            "textAlign": this.props.isContainerTelcel && !this.props.isClaroPartner ? "center" : "right",
            "borderBottom": `0px solid ${validation.borderValidInvalidColor}`,
            "color": `${validation.validInvalidAmountColor}`,
            "fontFamily":"AMX-Bold",
            "fontWeight": this.props.isContainerTelcel && !this.props.isClaroPartner ? "normal" : "bold",
            "width": `${this.context.inputWidth}px`,
            "height": "fit-content",
            "phColor": "black",
            "padding": "0rem"
        }
        styles = this.props.isClaroPartner ? {...styles, "fontFamily": 'SFProDisplayBold'} : styles;

        let stylesPesos = {
            "fontFamily": "AMX-Bold",
            "fontSize": "58px",
            "display": "block",
            "fontWeight": this.props.isContainerTelcel && !this.props.isClaroPartner ? "normal" : "bold",
        }
        stylesPesos = this.props.isClaroPartner ? {...stylesPesos, "fontFamily": 'AMX-Bold'} : stylesPesos;


        let inputData = this.props.input;
            inputData.title.titleStyle = this.props.isContainerTelcel && !this.props.isClaroPartner
            ? {
                ...inputData.title.titleStyle,
                fontFamily: "AMX-Bold",
                weight: "normal",
                fontColor: "#0f0f0f"
            }
            : inputData.title.titleStyle;
        let id = "pagoDeServicios_" + inputData.id + "_" + this.props.serviceName;
        let readonly = (inputData.field.input.disabled || this.props.amountPlan) ? true : false;

        let inputDataTitleStyle = inputData.title.titleStyle
        let inputDataSubtitleStyle = inputData.subTitle.subTitleStyle

        let favoritos = false; 

        if (this.props.dataConfigInputs[1] && this.props.dataConfigInputs[1].cp) {
            const input = this.props.dataConfigInputs[1].cp.find(input => input.id === 'favoritos');
            if (input) {
                favoritos = Boolean(input);
            }
        }

        return (
            <Container background = {this.props.isContainerTelcel && !this.props.isClaroPartner ? "#fff" : false}>
                {
                    (this.props.isClaroPartner) ?
                        <></> :
                        <ClaroParagraph
                            {...inputDataTitleStyle}
                            margin={this.props.isContainerTelcel ? "0px 0px 12px 0px" : undefined}
                        >
                            {inputData.title.text}
                        </ClaroParagraph>

                }
                <AmountWrap 
                    value={ this.props.value } 
                    giftImage = {
                        creditCardInfo &&
                        creditCardInfo.value &&
                        appSyncValues &&
                        appSyncValues.banks &&
                        appSyncValues.banks[0] &&
                        appSyncValues.banks[0].toggles &&
                        (
                            (creditCardInfo.value === "claro-pay" && appSyncValues.banks[0].toggles.SHOW_MEGAS_GIFT_N2) ||
                            (creditCardInfo.value !== "claro-pay" && appSyncValues.banks[0].toggles.SHOW_MEGAS_GIFT_CARD)
                        ) ? giftImage : ""
                    }>
                    <ClaroDiv {...styles}>
                        <ClaroDivPesos {...stylesPesos} aria-hidden="true">
                            $
                        </ClaroDivPesos>
                        <ClaroInputFieldPesos
                            {...styles}
                            pattern="[0-9]*"
                            inputMode="decimal"
                            type="text"
                            id={id}
                            name={inputData.field.input.name}
                            value={this.props.value}
                            onChange={this.props.handleInputChange}
                            onBlur={readonly ? () => false : () => false}
                            readOnly={readonly}
                            disabled={this.props.disabledAmountInput}
                            userAgentIsAndroid={this.props.userAgentIsAndroid}
                        />
                    </ClaroDiv>
                </AmountWrap>                    
                
                {
                    ARCUS_BILLER_IDS.includes(this.props.serviceId) && !this.props.isContainerTelcel && !this.props.canManageFavorites && !favoritos
                        ?
                        <>
                            <ArcusButtonsWrap>
                                { this.state.showBalanceButton ?
                                    <ArcusButton                                    
                                        color={this.props.isDisabledButtonArcusGetAmount ? "#6127282b" : "#50626c"}
                                        onClick={(e)=>{
                                            this.props.handleInputClick(e,"getAmountArcusBillers")
                                        }}>
                                        <img
                                            src={this.props.isDisabledButtonArcusGetAmount ? "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAM1BMVEVHcEymzVDW1tbBwcHr7ehaWlpYWFhZWVn///+Xl5fY6bLA2od7gmyGm1OlzE6mzU6wsLAkUOVUAAAAEXRSTlMAYWFhYVU8YWFhYWFfIlFAYXsxcnEAAADcSURBVEjH7ZXNDoQgDIStol3+xPd/2gVF1yyt0MRNPOycOPTL0DKkXfdo+YmRp+uR10jVT4iaEeJEACMuL0YLaTFizwGDDFDWOscB6qS9HJJmTwL6PBq31gNYoxLlqwAmwIJZjQxA05UU2NyJKSzIpk02SGhoA9R+hFnqQAF9kYqjB0v24IrYQbYoDRgHHd8hTixOdW6NBmwKbU2vjW9ZKohqWsNX28VLfx48x9vXsnRkkP8PYuD6Sj/7orcCRDT0cAU46ZTEDg+c0h+oA8KVJV6K0UK2duWL/Sl6A6lYJFFheyVAAAAAAElFTkSuQmCC" : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAwCAMAAACPHmKLAAAAYFBMVEVHcExZWVmmzEykzE2lzU6NqFClzU1aWlpaWlpvgVBZWVl4iVWky02lzU1aWlr///+YmJjr6+vX19elzU7CwsLV6Ku11HLr9Nb1+ettbW3J4ZSHh4exsbHh78WKpVKbo4sJm+8YAAAADnRSTlMAaFC/5CKo358Q3+dwYIT6e8YAAAD9SURBVEjH7ZbZEoIwDEVB2YpakUALZfv/vxS0KAMJtDM4w4P3iQfOZLshOM7BxdyIkMtQwA85qRBFIl4muCrOI4wIeX0nVPMQJ1KKyCwJqUR7IYnHRO/3CwGDvBNOJNMGlRoQTSEVwMmQUJC/QjXgsc2siqEGELqaHK5Glec6RJ8eBIaEHB/hbBlD4kQ6N0j3qUPBDSOqhQdbHUSC5xvFSDoBShYyB4JANM48WCKkr5rBV8wJFjPc9G4wN8pi5l9Darf7W77Sqlb3AyPK9Y1azeqHW7szkSJfq2yVqKx7ZR/jmL36E6aE7VWL+gUlTmeJX04W09c59vf5AziSnrIZS7FzV/AJAAAAAElFTkSuQmCC"}
                                            style={{ marginTop: '8px', height: '32px' }} />
                                        <p style={{ marginTop: '8px', marginBottom: '0px' }}>
                                            Consultar saldo
                                        </p>
                                    </ArcusButton> : <></>
                                }

                                {
                                    this.state.showArcusOCRButton 
                                    ?
                                    <ArcusButton
                                        color="#50626c"
                                        onClick={e => this.props.handleInputButtonFunction(e,'ocr')}
                                        margin="0px 0px 0px 12px">
                                        <img
                                            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAtBAMAAADINP+pAAAALVBMVEVHcExaWlpaWlpaWlpaWlqlzU5aXVZaWlpYWFhaWlqjzExaWlqmzk5aWlqmzk4t4+5YAAAADXRSTlMAYN+AxYEXmEjvSH/nj+p4bQAAAOhJREFUOMtj8L0LBLcZ4IAdxL/rwACmriDEWcACFxjuFgoKCoohxNmAXMFaoLgAAyaQpao4hxIYFDAUgWkPmDjEaXdvcEDoSzBxpivGQGB7kfEuiN6CEL8MMpMXKA6iuSHiJQlo4sxA8RQDEAtTHAIGnTg0HBjh4YAcpXensc0F09fhwdoIijvBBIYMMN3AQAiA1UskoAvDzEcXh7rnIoY41P0MDHHv3r07hUUcKPzu6cCKb0nAIp5SgJx+GBjOQcVR0xsDw9LQ0NAwhDg0XjDSsxM0PdMov2AXx5V/ceR3X9Qkw8AMKR8At57srwlLdcAAAAAASUVORK5CYII="
                                            style={{ marginTop: '12px', height: '30px' }} />
                                        <p style={{ marginTop: '8px', marginBottom: '0px' }}>
                                            Escanear
                                        </p>
                                    </ArcusButton>
                                    :
                                    <></>
                                }
                                
                            </ArcusButtonsWrap>
                        </>
                        :
                        <>
                            {
                                (
                                    !this.props.isClaroPartner && inputData.subTitle.text && 
                                    (
                                        (!this.props.canManageFavorites && !favoritos) || 
                                        (this.props.isContainerTelcel)
                                    )
                                ) ?
                                <ClaroSubtitleButton  
                                    {...inputDataSubtitleStyle} 
                                    serviceName={this.props.serviceName}
                                    text={inputDataSubtitleStyle.text}
                                    logicType = {this.props.logicType}
                                    isContainerTelcel = {this.props.isContainerTelcel}
                                    selectedPlan={this.props.selectedPlan}
                                >
                                    {inputData.subTitle.text}
                                </ClaroSubtitleButton> :
                                <></>
                            }
                        </>
                }
            </Container>
        )
    }
}

AmountInputClaroSocio.contextType = GenericFormContext;

function mapStateToProps(state) {
    const { payments } = state;
    return  {
        appSyncValues: payments.appSyncValues
    }
}

AmountInputClaroSocio = connect(mapStateToProps)(AmountInputClaroSocio);

export default AmountInputClaroSocio;